import { HTTP } from '@/services/axios';

export async function getCategories({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/ArticleCategory/getArticleCategoriesList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getCategory({categoryId}){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: `/app/core/ArticleCategory/getArticleCategoryData.php?categoryId=${categoryId}`,
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getCategoryOptions(){
    let result = [];
    
    await HTTP.get('/app/core/ArticleCategory/getArticleCategoryOptions.php',{})
    .then(response => {
        result = response.data;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function getCategoryChildsOptions(){
    let result = [];
    
    await HTTP.get('/app/core/ArticleCategory/getArticleCategoryOptionsChilds.php',{})
    .then(response => {
        result = response.data;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function unlockCategory({categoryId}){
    let result = {};

    var data = {'myRecordID':categoryId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/ArticleCategory/controlArticleCategoryUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateCategory({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state};

    await HTTP({
        method: 'patch',
        url: '/app/core/ArticleCategory/controlArticleCategoryChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createCategory({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/ArticleCategory/controlArticleCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveCategory({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/ArticleCategory/controlArticleCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteCategory({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/ArticleCategory/controlArticleCategoryDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}